import React from "react"

const Separator = ({ data, isBlog }) => {
  return (
    <section className="mb-0">
      <div className={isBlog ? " " : "container"}>
        <div
          className="separator"
          style={{
            backgroundColor: data?.seprator_color,
            marginTop: data?.top_margin,
            marginBottom: data?.bottom_margin,
          }}
        ></div>
      </div>
    </section>
  )
}

export default Separator
